import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'
import { Footer } from '#/components/layout/footer'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const location = useLocation()
  const showFooter = !location.pathname.includes('/lobby')

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
      <Footer showFooter={showFooter} />
    </div>
  )
}
